var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"previewPDF"}},[_c('div',{staticClass:"pdf-panel"},[_c('iframe',{staticClass:"iframe-panel",attrs:{"src":_vm.pdfSrc,"width":"100%","height":"100%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }